<template>
    <div class="error_wrapper">
         <div class="container text-center dark-blue-2">
            <h1 class="open-sans">We’re really sorry—something went wrong</h1>
            <p>Please return to the previous page and try again, or use some helpful links below that you may want to check out instead.</p>

            <ul>
                <li><router-link to="/#home">About JORNAY PM</router-link></li>
                <li class="has-submenu">
                    <a href="#" @click.prevent="openSubmenu">Why It's Different</a>
                    <ul class="sub-menu">
                        <li><router-link to="/#mod">Mechanism of Delivery</router-link></li>
                        <li><router-link to="/#pk-profile">Pharmacokinetic Profile</router-link></li>
                        <li><router-link to="/#dose-dependent">Dose-Dependent Duration</router-link></li>
                    </ul>
                </li>
                <li><router-link to="/#efficacy">All-Day Efficacy</router-link></li>
                <li><router-link to="/#dosingtitration">Dosing &amp; Titration</router-link></li>
                <li><router-link to="/#safety">Safety</router-link></li>
                <li class="has-submenu">
                    <a href="#" @click.prevent="openSubmenu">Savings &amp; Support</a>
                    <ul class="sub-menu">
                        <li><router-link to="/#savings-and-support">Patient Savings</router-link></li>
                        <!-- <li><router-link to="/#request-info">Request Info</router-link></li> -->
                    </ul>
                </li>
            </ul>
         </div>
    </div>
</template>

<script>
    export default {
        methods: {
            openSubmenu(e) {
                let opener = e.target;
                if (opener.nextElementSibling.classList.contains("open")) {
                    opener.nextElementSibling.classList.remove("open");
                } else {
                    opener.nextElementSibling.classList.add("open");
                }
            },
        }
    }
</script>
